module.exports = __webpack_public_path__ + "img/logo.b2647d81.png";